import fetcher from "../../lib/fetcher";
import { IFacilityTypeSchema } from "./use-facility-type";
import { IGeoPolygonsSchema } from "./use-geo-polygon";
import { toReadablePrice } from "../../lib/utils";
import useSWRMutation from "swr/mutation";
import { EMarketTypes } from "../../interfaces";

export interface IFacilityTypePriceRangeByPolygons {
  type: IFacilityTypeSchema;
  priceRanges: {
    searchPolygon: IGeoPolygonsSchema;
    minFacilityPrice?: number;
    maxFacilityPrice?: number;
  }[];
}

interface IFacilityTypePriceRangeByPolygonsResponse {
  data: IFacilityTypePriceRangeByPolygons[];
}

interface IFacilityTypePriceRangeByPolygonsRequest {
  facilityTypeIds: number[];
  searchPolygonIds: number[];
  marketType: EMarketTypes;
}

const ERROR_MESSAGE =
  "Ошибка запроса не удалось построить коридор цен по заданым диапазонам и планировке";

const useFacilityTypePriceRangeByPolygonsQuery = () => {
  async function fetchFacilityTypePriceRangeByPolygons(
    url: string,
    { arg }: { arg: IFacilityTypePriceRangeByPolygonsRequest }
  ) {
    try {
      const data = await fetcher.post(url, arg);

      if (error?.data) {
        throw ERROR_MESSAGE;
      }

      return data.result as IFacilityTypePriceRangeByPolygonsResponse;
    } catch (error) {
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/facility/type/price-range",
    fetchFacilityTypePriceRangeByPolygons
  );

  const facilityTypePriceRangeByPolygonsListTransform = (function () {
    return data
      ? data.data.map((dataItem) => ({
          typeId: dataItem.type.id,
          listRange: dataItem.priceRanges.map((dataItemPR) => ({
            priceFrom: dataItemPR.minFacilityPrice
              ? toReadablePrice(Math.round(dataItemPR.minFacilityPrice))
              : "0",
            priceTo: dataItemPR.maxFacilityPrice
              ? toReadablePrice(Math.round(dataItemPR.maxFacilityPrice))
              : "0",
            regionName: dataItemPR.searchPolygon.name,
          })),
        }))
      : [];
  })();

  return {
    facilityTypePriceRangeByPolygonsList:
      facilityTypePriceRangeByPolygonsListTransform ?? [],
    error,
    isMutating,
    trigger,
  };
};

export default useFacilityTypePriceRangeByPolygonsQuery;
